import React, { useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import { TokenType } from '@vatom/sdk/core'
import { GradientButton, Status, Text, Toast } from '@vatom/wombo'
import { Actionsheet, Divider, VStack } from 'native-base'

// import Success from './partials/Success'
import Alert from '../../../components/Alert'
import { useMaxWith } from '../../../components/WebWrapper'
import logger from '../../../logger'
import { AppRoutes } from '../../../navigators'
import ProcessButton from '../partials/ProcessButton'

interface ActionSheetUnSellProps {
  setOpen: (b: boolean) => void
  isOpen: boolean
  token: TokenType
}

export const ActionSheetUnSell = ({ isOpen, setOpen, token }: ActionSheetUnSellProps) => {
  logger.info('ActionSheetUnSell')
  const navigation = useNavigation()
  const [isLoading, setIsLoading] = useState(false)
  const maxWidth = useMaxWith()

  if (!isOpen) {
    return null
  }

  const unSellAction = async () => {
    if (!token) return

    setIsLoading(true)
    await token
      .performAction('varius.action:varius.io:remove-from-sale-v1')
      .then($ => {
        Toast({
          title: `Your NFT was successfully delisted.`,
          placement: 'top',
          status: Status.success
        })
      })
      .catch(Alert.showError)
    setIsLoading(false)
    setOpen(false)
    navigation.navigate(AppRoutes.home)
  }

  return (
    <Actionsheet
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      maxWidth={maxWidth}
      margin={'auto'}
      useRNModal={true}
      // @ts-ignore prop doesn't exit on types
      _backdropFade={{
        entryDelay: 150,
        exitDelay: 10
      }}
    >
      <Actionsheet.Content pt="20px" pb="16px" px={0}>
        <VStack w="100%" paddingX="16px">
          <Text textAlign="center">Are you sure you want to remove this vatom from Sale?</Text>
        </VStack>

        <Divider backgroundColor="gray.900" height="0px" mt={4} />
        <ProcessButton
          label="Remove"
          isDisabled={isLoading}
          onPress={unSellAction}
          isLoading={isLoading}
        />
        <Divider backgroundColor="gray.900" height="0px" mt={4} />

        <GradientButton
          colorScheme="gray"
          px={4}
          w="100%"
          justifyContent="center"
          onPress={() => setOpen(false)}
          disabled={isLoading}
        >
          <Text color="white" fontFamily="Inter-SemiBold" alignSelf="center" py={2} fontSize="18px">
            Cancel
          </Text>
        </GradientButton>
      </Actionsheet.Content>
      {/* )} */}
    </Actionsheet>
  )
}
export default ActionSheetUnSell
